import { OnboardingStyles } from "features/onboarding/common/styles";
import {
  EXTRA_INFO_TO_DESCRIPTION,
  EXTRA_INFO_TO_TITLE,
} from "@shared/features/onboarding/constants";
import Text from "common/Typography/Text";
import React, { useState } from "react";
import {
  ExternalAccountType,
  ExtraInfo,
} from "@shared/features/onboarding/types";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import styled from "styled-components";
import { setExpandedArray } from "@shared/features/onboarding/utils";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface ExternalAccountExtraInfoProps {
  selectedAccountType: ExternalAccountType;
  cardsDisplay?: boolean;
  hideExtraInfo?: ExtraInfo;
}

const ExternalAccountExtraInfo = ({
  selectedAccountType,
  cardsDisplay,
  hideExtraInfo: propsHideExtraInfo,
}: ExternalAccountExtraInfoProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const [expanded, setExpanded] = useState<boolean[]>([false, false]);

  const hideExtraInfo = (extraInfo: ExtraInfo) =>
    (selectedAccountType === ExternalAccountType.DISCORD &&
      extraInfo === ExtraInfo.UUID) ||
    extraInfo === propsHideExtraInfo;

  if (cardsDisplay || isMobile)
    return (
      <CardsWrapper>
        {Object.values(ExtraInfo).map((extraInfo, index) => (
          <div key={index}>
            {!hideExtraInfo(extraInfo) && (
              <OnboardingStyles.ExpandingCard
                key={index}
                expanded={expanded[index]}
                setExpanded={(value) =>
                  setExpandedArray(expanded, setExpanded, index, value)
                }
                showArrow={true}
                children={
                  <OnboardingStyles.ExpandingCardChildrenText>
                    {t(EXTRA_INFO_TO_TITLE[extraInfo])}
                  </OnboardingStyles.ExpandingCardChildrenText>
                }
                collapsibleContent={
                  <Text>{t(EXTRA_INFO_TO_DESCRIPTION[extraInfo])}</Text>
                }
              />
            )}
          </div>
        ))}
      </CardsWrapper>
    );

  return (
    <OnboardingStyles.InfoBackground style={{ marginBottom: 40 }}>
      <OnboardingStyles.BoldTitle>
        {t("external_account.why_connect_title")}
      </OnboardingStyles.BoldTitle>
      <Text>{t("external_account.why_connect_description")}</Text>
      {selectedAccountType === ExternalAccountType.TELEGRAM && (
        <>
          <OnboardingStyles.BoldTitle style={{ marginTop: 24 }}>
            {t("external_account.uuid_title")}
          </OnboardingStyles.BoldTitle>
          <Text>{t("external_account.uuid_description")}</Text>
        </>
      )}
    </OnboardingStyles.InfoBackground>
  );
};

export default ExternalAccountExtraInfo;

const CardsWrapper = styled.div`
  margin-top: 32px;
  width: 100%;
`;
